const FeedState = {
  FEED_NOT_INITIALIZED: 'FEED_NOT_INITIALIZED',
  FEED_INITIALIZING: 'FEED_INITIALIZING',
  FEED_INITIALIZED: 'FEED_INITIALIZED',
  FEED_ERROR: 'FEED_ERROR',
};

export default FeedState;
